import { render } from "./SectionsDetailQuestions.vue?vue&type=template&id=f06c203e"
import script from "./SectionsDetailQuestions.vue?vue&type=script&lang=js"
export * from "./SectionsDetailQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__